import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Controller, UseFormReturn } from "react-hook-form";

import dayjs from "dayjs";

/**
 * onTipoData
 */

const onTipoData = (tipo: string) => {
  switch (tipo) {
    case 'dia':
      return "DD/MM";
    case 'mes':
      return "MM/YYYY";
    case 'ano':
      return "YYYY";
    case 'completo':
      return "DD/MM/YYYY";
    default:
      return "DD/MM/YYYY";
  }
};

/**
 * DefaultFormDatePickerInput
 */

type Props<T extends {}> = {
  name: keyof T,
  label: string,
  required?: boolean,
  readOnly?: boolean,
  tipoData?: ('dia' | 'mes' | 'ano' | 'completo'),
  views?: ('year' | 'month' | 'day')[]
  reactHookForm: UseFormReturn<T>,
};


export const DefaultFormDatePickerInput = <T extends {},>({
  name,
  label,
  required,
  readOnly,
  reactHookForm,
  views = ['day', 'month', 'year'],
  tipoData = 'completo'
}: Props<T>) => {
  return (
    <Controller
      name={name as any}
      control={reactHookForm.control}
      render={({ field, formState }) => {
        let helperText = null;
        let errors = formState.errors as any;

        if (errors[name]) {
          const error = errors[name] as any;
          if (typeof error.message === 'string') {
            helperText = error.message;
          }
        }

        return (
          <DatePicker
            views={views}
            format={onTipoData(tipoData)}
            slotProps={{
              field: {
                clearable: true,
                onClear: () => field.onChange?.(null),
              },
              textField: {
                label: label,
                size: 'small',
                fullWidth: true,
                required: required,
                error: helperText !== null,
                helperText: helperText,
                disabled: formState.disabled,
                readOnly: readOnly,
              },
            }}
            readOnly={readOnly}
            label={label}
            value={field.value ? dayjs.utc(field.value as any).local() : null}
            onChange={v => {
              if (v === null || v.isValid()) field.onChange(v?.toDate() ?? null);
            }}
          />
        );
      }} />

  );
}
